<div class="flex flex-column h-full w-full">
  <div class="flex flex-column overflow-hidden h-full">
    <selfai-platform-code-editor
      [value]="editorContent()"
      [language]="codeLanguage.REGEXP"
      [canMaximized]="false"
      class="h-full w-full"
    ></selfai-platform-code-editor>
  </div>
</div>
